/* PDP – Wendebettwaesche-Konfigurator. Seit 16.07.2026 reine Konfigurator-Logik:
   Markup, Platzierung, Option-Label und form-Attribute kommen vollstaendig aus Liquid
   (snippets/pdp-wende.liquid, gerendert von sections/pdp-main.liquid) – kein
   DOM-Verschieben, kein Label-Fix, kein Umsortieren von Hinweis/Lieferdatum mehr.

   Zweistufige Auswahl je Seite: erst Dessin, dann Look. Hell und Dunkel sind zwei
   eigenstaendige Looks und bekommen je eine eigene Kachel – kein Schalter.

   ACHTUNG: Sichtbarkeit NIE ueber das hidden-Attribut steuern, wenn das Element eine Klasse
   mit display-Regel hat (.pdp-sample-btn traegt hidden-phone / hidden-lap-and-up). Die Klasse
   schlaegt [hidden]. Deshalb ueberall show().

   Warenkorb (Focal-Konvention, siehe Doku-Kopf in assets/custom.js und AddSamplesToCart):
   nach dem Hinzufuegen BEIDE Events feuern – cart:refresh UND cart:updated – und den
   Mini-Cart ueber #mini-cart.open = true oeffnen. Ein cart:refresh allein tut sichtbar nichts.

   HOFFMANN 19.07.2026: Das Knopfleisten-Label fuer "fuss" kommt jetzt aus
   cfg.knopfFussLabel (von Liquid gesetzt, z.B. "Am Umschlag" bei Kissenbezuegen statt
   "Am Fussende" bei Bettbezuegen) statt hart codiert zu sein. Fallback auf 'Am Fußende',
   falls ein aelterer Cache-Stand ohne das Feld auftaucht.

   HOFFMANN 09.08.2026: Die Frage nach der Seite erscheint jetzt in BEIDEN Macharten, nicht
   mehr nur bei "Hochgesetzt". Bei "Hochgesetzt" geht es weiterhin um die Lage der
   Knopfleiste, bei "Am Fussende"/"Am Umschlag" nur darum, auf welcher Seite die Knoepfe
   sichtbar sind. Fragetext und Name der Line Item Property werden deshalb zur Laufzeit
   gesetzt: properties[Knopfleiste auf Seite] bzw. properties[Knoepfe sichtbar auf Seite].

   HOFFMANN 10.08.2026 – Mobile Neufassung (unter 1000 px):
   Die zweite Bedienoberflaeche (vier Schritte plus Uebersicht in einem Bottom-Sheet
   ueber dem Bild) liegt in assets/pdp-wende-mobile.js. Sie ist eine reine Praesentationsschicht. Zustand, Hidden-Inputs,
   Property-Namen, das Event wende:change und die Muster-Logik bleiben unveraendert –
   es gibt weiterhin genau eine Quelle je Wert. Schritt 3 und der Kissenbezug-Block
   werden nicht kopiert, sondern per DOM-Verschiebung in die Panels geholt und beim
   Wechsel auf Desktop zurueckgestellt.
   Die Desktop-Ansicht laeuft unveraendert durch: alles Neue haengt an MQ.matches. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp-wende]');
  var cfgEl = document.querySelector('[data-pdp-wende-config]');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.stoffe || !cfg.stoffe.length) return;

  function show(el, on) {
    if (!el) return;
    el.removeAttribute('hidden');
    if (on) el.style.removeProperty('display');
    else el.style.setProperty('display', 'none', 'important');
  }

  var form = document.querySelector('form.pdp-form') ||
             document.querySelector('form[action*="/cart/add"]');

  var musterBox = document.querySelector('[data-pdp-wende-muster]');
  var drawerBtns = Array.prototype.slice.call(document.querySelectorAll('.pdp-sample-btn'));
  var drawerNote = document.querySelector('.pdp-sample-note');

  var SIDE_WORD = { hell: 'helle', dunkel: 'dunkle' };
  var SIDE_CODE = { hell: 'H', dunkel: 'D' };

  var state = { combo: null, A: null, B: null, dessinA: null, dessinB: null, knopf: 'fuss', knopfSeite: null };

  cfg.stoffe.sort(function (a, b) { return (a.sort || 999) - (b.sort || 999); });

  function byHandle(h) {
    for (var i = 0; i < cfg.stoffe.length; i++) if (cfg.stoffe[i].handle === h) return cfg.stoffe[i];
    return null;
  }
  function parseKey(key) {
    if (!key) return null;
    var p = key.split('|');
    var s = byHandle(p[0]);
    return s ? { stoff: s, flip: p[1] || null } : null;
  }

  /* HOFFMANN 10.08.2026 – Regex korrigiert. Vorher: /(\d{4})\D*(\d{2})\D*([HD])?\s*$/.
     Das gierige \D* vor der optionalen Gruppe verschluckte das Suffix: bei der SKU
     „Muster 01 3606-01-H" fraß es „-H", die Gruppe blieb leer und der Treffer wurde
     verworfen. Damit fand KEIN einziger Hell/Dunkel-Stoff sein Muster, der Ein-Klick-Knopf
     blieb bei genau diesen Stoffen aus. Jetzt sucht ein sparsames \D*? gezielt nach dem
     H oder D, und ein abschliessendes \D*$ laesst beliebige weitere Zeichen zu. */
  function musterFor(sel) {
    if (!sel || !cfg.musterVarianten) return null;
    var c = sel.stoff.code.match(/(\d{4})\s+(\d{2})/);
    if (!c) return null;
    var want = sel.flip ? SIDE_CODE[sel.flip] : null;
    for (var i = 0; i < cfg.musterVarianten.length; i++) {
      var mv = cfg.musterVarianten[i];
      var m = (mv.sku || '').match(/(\d{4})\D*(\d{2})(?:\D*?([HD]))?\D*$/);
      if (!m || m[1] !== c[1] || m[2] !== c[2]) continue;
      if (want) { if (m[3] !== want) continue; } else if (m[3]) continue;
      return mv;
    }
    return null;
  }

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function readCombo() {
    var el = document.querySelector('input[name="option1"]:checked') ||
             document.querySelector('select[name="option1"]');
    return el ? el.value : null;
  }
  function qualitiesOf(combo) {
    if (!combo) return null;
    var p = combo.split('&').map(function (x) { return x.trim(); });
    if (p.length !== 2) return null;
    var a = cfg.qualityMap[p[0]], b = cfg.qualityMap[p[1]];
    return (a && b) ? [a, b] : null;
  }
  function stoffeFor(q) { return cfg.stoffe.filter(function (s) { return s.qualitaet === q; }); }
  function dessinsFor(q) {
    var seen = [];
    stoffeFor(q).forEach(function (s) { if (seen.indexOf(s.dessin) === -1) seen.push(s.dessin); });
    return seen;
  }
  function labelOf(sel) {
    return sel ? sel.stoff.name + (sel.flip ? ', ' + SIDE_WORD[sel.flip] + ' Seite' : '') : '';
  }
  function propText(sel) {
    if (!sel) return '';
    return labelOf(sel) + ' (' + sel.stoff.code + (sel.flip ? ' ' + SIDE_CODE[sel.flip] : '') + ')';
  }
  function setProp(key, value) {
    var el = root.querySelector('[data-pdp-wende-prop="' + key + '"]');
    if (!el) return;
    if (value) { el.value = value; el.disabled = false; }
    else { el.value = ''; el.disabled = true; }
  }

  function renderSide(side) {
    var wrap = root.querySelector('[data-pdp-wende-side="' + side + '"]');
    if (!wrap) return;
    var dKey = 'dessin' + side;
    var quals = qualitiesOf(state.combo);
    var quality = quals ? quals[side === 'A' ? 0 : 1] : null;
    wrap.querySelector('[data-pdp-wende-quality]').textContent = quality || '—';

    var dessins = quality ? dessinsFor(quality) : [];
    if (dessins.indexOf(state[dKey]) === -1) state[dKey] = dessins.length ? dessins[0] : null;

    var sel = parseKey(state[side]);
    if (sel && (sel.stoff.qualitaet !== quality || (dessins.length > 1 && sel.stoff.dessin !== state[dKey]))) {
      state[side] = null; sel = null;
    }

    var dBox = wrap.querySelector('[data-pdp-wende-dessins]');
    dBox.innerHTML = '';
    show(dBox, dessins.length > 1);
    if (dessins.length > 1) {
      dessins.forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-wende__dessin' + (state[dKey] === d ? ' is-active' : '');
        b.textContent = d.replace(/^Damast /, '');
        b.setAttribute('aria-pressed', state[dKey] === d ? 'true' : 'false');
        b.onclick = function () {
          if (state[dKey] === d) return;
          state[dKey] = d; state[side] = null; render();
        };
        dBox.appendChild(b);
      });
    }

    var list = quality ? stoffeFor(quality).filter(function (s) {
      return dessins.length < 2 || s.dessin === state[dKey];
    }) : [];

    var box = wrap.querySelector('[data-pdp-wende-swatches]');
    box.innerHTML = '';
    list.forEach(function (s) {
      var flips = (s.wendbar && s.imgDark) ? ['hell', 'dunkel'] : [null];
      flips.forEach(function (flip) {
        var key = flip ? s.handle + '|' + flip : s.handle;
        var isOn = state[side] === key;
        var img = (flip === 'dunkel') ? s.imgDark : s.img;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-wende__swatch' + (isOn ? ' is-active' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', isOn ? 'true' : 'false');
        b.setAttribute('aria-label', s.name + (flip ? ', ' + SIDE_WORD[flip] + ' Seite' : ''));
        b.title = (s.farbe || s.name) + (flip ? ' · ' + flip : '');
        b.innerHTML = (img
          ? '<img src="' + img + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="pdp-wende__swatch-fallback"></span>') +
          (flip ? '<span class="pdp-wende__swatch-tag">' + flip + '</span>' : '');
        b.addEventListener('click', function () {
          state[side] = (state[side] === key) ? null : key;
          render();
        });
        box.appendChild(b);
      });
    });

    var chosenEl = wrap.querySelector('[data-pdp-wende-chosen]');
    if (sel) {
      chosenEl.innerHTML = '<strong>' + propText(sel) + '</strong>' +
        (sel.stoff.muster ? ' · <a href="' + sel.stoff.muster + '">Muster bestellen</a>' : '');
      chosenEl.classList.add('is-set');
    } else {
      chosenEl.textContent = 'Noch kein Stoff gewählt';
      chosenEl.classList.remove('is-set');
    }
  }

  /* HOFFMANN 10.08.2026: Die Knopfleisten-Karten werden ueber document gesucht, nicht
     ueber root. Auf Mobil verschiebt assets/pdp-wende-mobile die Karten in Schritt 3 des
     Sheets und damit aus .pdp-wende heraus. Die Hidden-Inputs bleiben in root, dafuer
     gilt weiterhin root.querySelector. */
  function renderKnopf() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-wende-knopf]'), function (b) {
      var v = b.getAttribute('data-pdp-wende-knopf');
      b.classList.toggle('is-active', v === state.knopf);
      b.onclick = function (e) {
        /* HOFFMANN 09.08.2026: Beide Info-Icons duerfen die Karte nicht umschalten. */
        if (e.target.closest('[data-pdp-wende-info]') || e.target.closest('[data-pdp-wende-info2]')) return;
        state.knopf = v;
        /* HOFFMANN 09.08.2026: knopfSeite wird beim Wechsel der Machart NICHT mehr
           zurueckgesetzt – die Frage nach der Seite gibt es jetzt in beiden Macharten,
           die einmal gewaehlte Seite bleibt deshalb erhalten. */
        render();
      };
    });
    var wrap = document.querySelector('[data-pdp-wende-knopfseite]');
    if (!wrap) return;
    show(wrap, true);
    setProp('knopf', state.knopf === 'fuss' ? (cfg.knopfFussLabel || 'Am Fußende') : 'Hochgesetzt');

    /* HOFFMANN 09.08.2026: Der Seiten-Block ist immer sichtbar. Bei „Hochgesetzt" geht es
       um die Lage der Knopfleiste, bei „Am Fußende"/„Am Umschlag" nur darum, auf welcher
       Seite die Knoepfe zu sehen sind – deshalb anderer Fragetext und anderer Property-Name. */
    var isHotel = state.knopf === 'hotel';
    var labelEl = wrap.querySelector('[data-pdp-wende-knopfseite-label]');
    if (labelEl) {
      labelEl.textContent = isHotel
        ? 'Auf welcher Seite soll die Knopfleiste liegen?'
        : 'Auf welcher Seite sollen die Knöpfe zu sehen sein?';
    }
    var seiteEl = root.querySelector('[data-pdp-wende-prop="knopfseite"]');
    if (seiteEl) {
      seiteEl.setAttribute('name', isHotel
        ? 'properties[Knopfleiste auf Seite]'
        : 'properties[Knöpfe sichtbar auf Seite]');
    }

    var box = wrap.querySelector('[data-pdp-wende-knopfseite-btns]');
    box.innerHTML = '';
    ['A', 'B'].forEach(function (side) {
      var sel = parseKey(state[side]);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-wende__card pdp-wende__card--side pdp-wende__card--' + side.toLowerCase() +
        (state.knopfSeite === side ? ' is-active' : '');
      b.disabled = !sel;
      b.innerHTML = '<span class="pdp-wende__card-title">Seite ' + side + '</span>' +
        '<span class="pdp-wende__card-text">' + (sel ? labelOf(sel) : 'erst Stoff wählen') + '</span>';
      b.onclick = function () { state.knopfSeite = side; render(); };
      box.appendChild(b);
    });
    var s = state.knopfSeite ? parseKey(state[state.knopfSeite]) : null;
    setProp('knopfseite', s ? 'Seite ' + state.knopfSeite + ' — ' + propText(s) : null);
  }

  /* Ein-Klick-Muster. Drawer-Button bleibt, solange nichts gewaehlt ist –
     wer nichts weiss, will stoebern. Danach uebernimmt der zielgenaue Button. */
  var musterState = { a: null, b: null };
  function renderMuster() {
    var a = parseKey(state.A), b = parseKey(state.B);
    var ma = a ? musterFor(a) : null, mb = b ? musterFor(b) : null;
    var both = !!(ma && mb && ma.available && mb.available);
    musterState.a = ma; musterState.b = mb;

    if (musterBox) {
      show(musterBox, both);
      drawerBtns.forEach(function (el) { show(el, !both); });
      show(drawerNote, !both);
      if (both) {
        var one = mb.id === ma.id;
        musterBox.querySelector('[data-pdp-wende-muster-label]').textContent =
          (one ? 'Das ausgewählte Muster erst fühlen' : 'Die ausgewählten Muster erst fühlen') +
          ' · ' + money(ma.price + (one ? 0 : mb.price));
      }
    }
    return both;
  }

  function musterTotal() {
    var ma = musterState.a, mb = musterState.b;
    if (!ma || !mb) return 0;
    return ma.price + (mb.id === ma.id ? 0 : mb.price);
  }

  /* HOFFMANN 10.08.2026: nimmt den ausloesenden Button entgegen, damit derselbe
     Ablauf sowohl unter dem Desktop-CTA als auch in der mobilen Uebersicht laeuft. */
  function addMuster(btn) {
    var ma = musterState.a, mb = musterState.b;
    if (!ma || !mb) return;
    var items = [{ id: ma.id, quantity: 1 }];
    if (mb.id !== ma.id) items.push({ id: mb.id, quantity: 1 });
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () {
      /* Focal: beide Events, dann Mini-Cart oeffnen – genau wie AddSamplesToCart. */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      var mini = document.getElementById('mini-cart');
      if (mini) mini.open = true;
    }).catch(function () {
      alert('Es gab ein Problem beim Hinzufügen der Muster. Bitte versuchen Sie es erneut.');
    }).then(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  }
  if (musterBox) {
    var musterBtn = musterBox.querySelector('[data-pdp-wende-muster-btn]');
    musterBtn.addEventListener('click', function () { addMuster(musterBtn); });
  }

  function missing() {
    var m = [];
    if (!state.A) m.push('Seite A');
    if (!state.B) m.push('Seite B');
    /* HOFFMANN 09.08.2026: Die Seite ist jetzt in beiden Macharten Pflicht. */
    if (!state.knopfSeite) {
      m.push(state.knopf === 'hotel' ? 'die Seite für die Knopfleiste' : 'die Seite für die Knöpfe');
    }
    return m;
  }

  var cta = null;
  function getCta() {
    if (cta && document.contains(cta)) return cta;
    cta = document.querySelector('[data-product-add-to-cart-button]');
    return cta;
  }
  var lockValid = true;
  function applyLock(valid) {
    lockValid = valid;
    var b = getCta();
    if (!b) return;
    b.classList.toggle('pdp-wende-blocked', !valid);
    if (!valid) b.setAttribute('aria-disabled', 'true');
    else b.removeAttribute('aria-disabled');
  }

  function render() {
    renderSide('A');
    renderSide('B');
    renderKnopf();
    renderMuster();

    var a = parseKey(state.A), b = parseKey(state.B);
    setProp('A', a ? propText(a) : null);
    setProp('B', b ? propText(b) : null);

    show(root.querySelector('[data-pdp-wende-warn]'), !!(state.A && state.B && state.A === state.B));

    var m = missing();
    /* HOFFMANN 10.08.2026: Auf Mobil gibt es weder die Zeile „Bitte noch … wählen"
       noch einen blockierten Knopf – der Bestellknopf existiert dort erst in der
       Uebersicht, und dorthin kommt nur, wer vollstaendig gewaehlt hat. */
    if (MQ.matches) {
      show(root.querySelector('[data-pdp-wende-notice]'), false);
      applyLock(true);
    } else {
      show(root.querySelector('[data-pdp-wende-notice]'), m.length > 0);
      if (m.length) {
        root.querySelector('[data-pdp-wende-notice-text]').textContent =
          'Bitte noch ' + m.join(' und ') + ' wählen.';
      }
      applyLock(m.length === 0);
    }

    dispatchChange(a, b);
    if (W.onRender) W.onRender();
  }

  /* HOFFMANN 25.07.2026: Konfigurator meldet seinen Stand nach außen, damit der
     Mitbestell-Block (snippets/pdp-wende-partner.liquid + assets/pdp-addons.js) erst
     nach vollständiger Stoffwahl erscheint und Stoffkombination, gewählte Stoffe
     (Seite A/B) sowie die Knopfleisten-Einstellung erben kann. Reines Melden – der
     Block liest daraus, der Konfigurator kennt ihn nicht. */
  function dispatchChange(a, b) {
    var knopfEl = root.querySelector('[data-pdp-wende-prop="knopf"]');
    var knopfSeiteEl = root.querySelector('[data-pdp-wende-prop="knopfseite"]');
    var detail = {
      combo: state.combo,
      bothChosen: !!(state.A && state.B),
      seiteA: a ? propText(a) : null,
      seiteB: b ? propText(b) : null,
      knopf: state.knopf,
      knopfLabel: (knopfEl && !knopfEl.disabled) ? knopfEl.value : null,
      knopfSeiteLabel: (knopfSeiteEl && !knopfSeiteEl.disabled) ? knopfSeiteEl.value : null,
      keyA: state.A || null,
      keyB: state.B || null
    };
    document.dispatchEvent(new CustomEvent('wende:change', { detail: detail }));
    window.__wendeState = detail;
  }

  /* HOFFMANN 09.08.2026: Es gibt jetzt zwei Info-Popups (Hochgesetzt und Fußende/Umschlag).
     Die Verdrahtung ist identisch und steckt deshalb in einer kleinen Hilfsfunktion statt in
     einem kopierten Block. Escape schließt beide – dafür ein gemeinsamer Listener. */
  var popups = [];
  function wirePopup(popupSel, infoSel) {
    var popup = document.querySelector(popupSel);
    if (!popup) return;
    var infoBtn = root.querySelector(infoSel);
    if (infoBtn) {
      infoBtn.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault(); show(popup, true);
      });
      infoBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); show(popup, true); }
      });
    }
    Array.prototype.forEach.call(popup.querySelectorAll('[data-pdp-wende-popup-close]'), function (el) {
      el.addEventListener('click', function () { show(popup, false); });
    });
    show(popup, false);
    popups.push(popup);
  }
  wirePopup('[data-pdp-wende-popup]', '[data-pdp-wende-info]');
  wirePopup('[data-pdp-wende-popup2]', '[data-pdp-wende-info2]');
  if (popups.length) {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      popups.forEach(function (p) { show(p, false); });
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (lockValid) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      root.classList.add('is-shaking');
      setTimeout(function () { root.classList.remove('is-shaking'); }, 600);
    }, true);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !/^option\d$/.test(e.target.name || '')) return;
    var next = readCombo();
    if (next !== state.combo) { state.combo = next; render(); }
    else if (W.onRender) W.onRender();
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-product-add-to-cart-button]');
    if (b && !lockValid) { e.preventDefault(); e.stopImmediatePropagation(); render(); }
  }, true);
  /* =========================================================================
     Schnittstelle zum Mobil-Modul (assets/pdp-wende-mobile.js)
     -------------------------------------------------------------------------
     HOFFMANN 10.08.2026: Der mobile Sheet-Konfigurator liegt in einer eigenen
     Datei, weil beides zusammen zu gross fuer einen Theme-Upload wurde. Der Kern
     kennt das Modul nicht. Er legt seine Bausteine auf window.WendeCore und ruft
     nach jedem Rendern onRender auf, sofern das Modul geladen ist. Fehlt die
     Datei, laeuft die Desktop-Ansicht unveraendert weiter.

     Beide Dateien laufen mit defer und in Dokumentreihenfolge: erst der Kern,
     dann das Modul. Der Start haengt deshalb an DOMContentLoaded und nicht am
     Ende dieser Datei, sonst waere onInit beim Booten noch nicht gesetzt.
     ========================================================================= */
  var MQ = window.matchMedia('(max-width: 999px)');

  var W = {
    cfg: cfg, state: state, root: root, form: form, MQ: MQ,
    SIDE_WORD: SIDE_WORD, SIDE_CODE: SIDE_CODE,
    show: show, byHandle: byHandle, parseKey: parseKey, money: money,
    readCombo: readCombo, qualitiesOf: qualitiesOf, stoffeFor: stoffeFor,
    dessinsFor: dessinsFor, labelOf: labelOf, propText: propText,
    musterState: musterState, musterTotal: musterTotal, addMuster: addMuster,
    render: render,
    onInit: null,
    onRender: null
  };
  window.WendeCore = W;
  /* Das Mobil-Modul steht als Inline-Block im Snippet und laeuft damit frueher als
     diese defer-Datei. Es wartet deshalb notfalls auf dieses Ereignis. */
  document.dispatchEvent(new CustomEvent('wende:core-ready', { detail: W }));

  function boot() {
    state.combo = readCombo();
    if (W.onInit) W.onInit();
    render();
  }
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
